import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, TextField, InputAdornment, CircularProgress } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import BreadcrumbManual from '../components/help/BreadcrumbManual';
import MarkdownRenderer from '../components/help/MarkdownRenderer';

const API = process.env.REACT_APP_API_URL || '';

export default function GlosarioManual() {
  const navigate = useNavigate();
  const [contenido, setContenido] = useState('');
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState(null);
  const [query, setQuery] = useState('');

  useEffect(() => {
    fetch(`${API}/api/ayuda-content/glosario.md`)
      .then(r => { if (!r.ok) throw new Error(); return r.text(); })
      .then(setContenido)
      .catch(() => setError('El glosario aún no está disponible.'))
      .finally(() => setCargando(false));
  }, []);

  return (
    <Box sx={{ maxWidth: 680 }}>
      <BreadcrumbManual tituloArticulo="Glosario" />

      <Box sx={{ mb: 3 }}>
        <Typography variant="h6" sx={{ fontWeight: 700, color: '#e0e0e0', mb: 0.5 }}>
          📖 Glosario
        </Typography>
        <Typography sx={{ color: '#90a4ae', fontSize: 14 }}>
          Significado de los términos que usa Gestar.
        </Typography>
      </Box>

      <TextField
        fullWidth
        placeholder="Buscar término..."
        value={query}
        onChange={e => setQuery(e.target.value)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon sx={{ color: '#546e7a', fontSize: 18 }} />
            </InputAdornment>
          ),
          style: { color: '#e0e0e0', fontSize: 14 },
        }}
        sx={{
          mb: 3,
          '& .MuiOutlinedInput-root fieldset': { borderColor: 'var(--c-primario)' },
          '& .MuiOutlinedInput-root:hover fieldset': { borderColor: 'var(--c-acento)' },
          '& .MuiOutlinedInput-root.Mui-focused fieldset': { borderColor: 'var(--c-acento)' },
        }}
      />

      <Box sx={{
        bgcolor: 'var(--c-superficie)', borderRadius: 2,
        border: '1px solid rgba(255,255,255,0.06)', p: { xs: 2, sm: 3 }, minHeight: 200,
      }}>
        {cargando ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
            <CircularProgress size={28} sx={{ color: 'var(--c-acento)' }} />
          </Box>
        ) : error ? (
          <Box sx={{ textAlign: 'center', py: 6 }}>
            <Typography sx={{ fontSize: 32, mb: 2 }}>🔧</Typography>
            <Typography sx={{ color: '#90a4ae', fontSize: 14 }}>{error}</Typography>
          </Box>
        ) : (
          <ContenidoFiltrado contenido={contenido} query={query} />
        )}
      </Box>
    </Box>
  );
}

function ContenidoFiltrado({ contenido, query }) {
  if (!query.trim()) {
    return <MarkdownRenderer>{contenido}</MarkdownRenderer>;
  }

  const lineas = contenido.split('\n');
  const q = query.toLowerCase();
  const seccionesMatch = [];
  let seccionActual = [];
  let encabezadoActual = '';
  let dentroMatch = false;

  for (const linea of lineas) {
    if (linea.startsWith('## ') || linea.startsWith('### ')) {
      if (dentroMatch && seccionActual.length) {
        seccionesMatch.push(seccionActual.join('\n'));
      }
      encabezadoActual = linea;
      seccionActual = [linea];
      dentroMatch = linea.toLowerCase().includes(q);
    } else {
      seccionActual.push(linea);
      if (linea.toLowerCase().includes(q)) dentroMatch = true;
    }
  }
  if (dentroMatch && seccionActual.length) seccionesMatch.push(seccionActual.join('\n'));

  if (!seccionesMatch.length) {
    return (
      <Typography sx={{ color: '#546e7a', fontSize: 14 }}>
        No se encontraron términos para "{query}".
      </Typography>
    );
  }

  return <MarkdownRenderer>{seccionesMatch.join('\n\n---\n\n')}</MarkdownRenderer>;
}
